import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sc-navbar" }
const _hoisted_2 = { class: "sc-navbar-items" }
const _hoisted_3 = { class: "sc-row" }
const _hoisted_4 = { class: "sc-column" }
const _hoisted_5 = { class: "sc-row sc-title" }
const _hoisted_6 = { class: "sc-row" }
const _hoisted_7 = { class: "sc-subtext" }


import { useRoute } from "vue-router";
import { CertificationSlimVM } from "@/types/certifications";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationsNavbar',
  props: {
    certifications: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.certifications, (certification) => {
        return (_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(["sc-navbar-button sc-navbar-item", [{ active: certification.id === Number(_unref(route).params.id) }]]),
          key: certification.id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sc-column sc-icon-container" }, [
              _createElementVNode("span", { class: "icon-money-solid" })
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(certification?.certifiedAmountDisplay), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, "Sequence #" + _toDisplayString(certification?.sequenceNumber), 1)
              ])
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})